// import React, { useEffect, useState } from "react"
// import './App.css';
// import $ from "jquery";
// class ApiTest extends React.Component {

//   // Constructor
//   constructor(props) {
//     super(props);

//     this.state = {
//       items: [],
//       DataisLoaded: false
//     };
//   }

//   // ComponentDidMount is used to
//   // execute the code
//   componentDidMount() {
//     debugger;
//     const requestOptions = {
//       "mode": "no-cors",
//       "Content-Type": "application/json",
//       "Access-Control-Allow-Origin": "*",
//       "Access-Control-Allow-Credentials": true
//     };
//     fetch("https://localhost:44315/api/foodorder")
//       .then((res) => res.json())
//       .then((response) => {
//         this.setState({
//           items: response,
//           DataisLoaded: true
//         });
//       })
//       .catch(function (err) {
//         console.log(err)
//       });
//   }
//   render() {
//     const { DataisLoaded, items } = this.state;
//     if (!DataisLoaded) return <div>
//       <h1> Pleses wait some time.... </h1> </div>;

//     return (
//       <div className="App">
//         <h1> Fetch data from an api in react </h1> {
//           items.map((item) => (
//             <ol key={item?.Attributes[0].Value} >
//               User_Name: {item?.Attributes[1]?.Value},
//               Allocated Points: { item?.Attributes[4]?.Value},
//               Available Points: { item?.Attributes[3]?.Value},
//               On-Hold Points: {item?.Attributes[2]?.Value}
//             </ol>
//           ))
//         }
//       </div>
//     );
//   }
// }

// export default ApiTest;